import { message, Modal } from 'antd';
import React, { forwardRef, useCallback, useEffect, useImperativeHandle, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { createEmployeeSalaryStructure, deleteEmployeeSalaryStructure, fetchEmployeeSalaryStructures, fetchSalaryStructureLogsByEmployeeId, updateEmployeeSalaryStructure } from '../../../../core/data/redux/payroll/payrollStructure/payrollStructure/employeeSalaryStructureActions';
import { AppDispatch, RootState } from '../../../../core/data/redux/store';
import { filterByStatus } from '../../../../core/utils/filterActiveData';
import { status } from '../../../../core/common/selectoption/selectoption';
import { today } from '../../../../core/utils/FormatData';
import { formatDate as FormatFeildDate } from "../../../../core/common/GlobalFunctions/DateFormats";
import { getEmployees } from '../../../../core/data/redux/employee/employeeAction';
import { fetchPayscales } from '../../../../core/data/redux/payroll/payrollComponent/payscale/payscaleActions';
import { fetchEarnings } from '../../../../core/data/redux/payroll/payrollComponent/earning/earningActions';
import { fetchDeductions } from '../../../../core/data/redux/payroll/payrollComponent/deduction/deductionActions';
import { fetchOvertimePays } from '../../../../core/data/redux/payroll/payrollComponent/overtimePayRate/overtimePayActions';
import { filterData } from '../../../../core/common/GlobalFunctions/tableFilters';
import { useAppConfig } from '../../../../customhooks/useAppConfig';
import { formatCurrency } from '../../../../core/utils/configFormatters';
import { formatDate as dateFormat } from "../../../../core/utils/configFormatters";
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';

interface EarningDeductionItem {
    name: string;
    calculateUpon?: string; // Optional as it might not be present initially
    percent?: string;      // Assuming percent is stored as string
    id: string;            // ID from the master list (EarningID/DeductionID)
    amount: number;
    earning_id?: string;   // This seems to be the primary key from backend table `employee_salary_earnings`
    deduction_id?: string; // This seems to be the primary key from backend table `employee_salary_deductions`
}

interface EditingSectionsSalaryStruct {
    EditsalaryStructure: boolean;
    [key: string]: boolean | undefined;
}

interface EmployeeSalaryStructureModalProps {
    modalType: "edit" | "create" | "";
    selectedRowData: any;
    isModalVisible: boolean;
    setIsModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setTableKey: React.Dispatch<React.SetStateAction<number>>;
    // onSubmit?: () => void;
    employeeId?: string
    editingSlaryStruct: EditingSectionsSalaryStruct;
    setEditingSalaryStruct: React.Dispatch<React.SetStateAction<EditingSectionsSalaryStruct>>;
}

const EmployeeSalaryStructureModal = forwardRef<
    any, // <- type of exposed methods
    EmployeeSalaryStructureModalProps
>(({
    modalType,
    isModalVisible,
    setIsModalVisible,
    setTableKey,
    employeeId,
    editingSlaryStruct,
    setEditingSalaryStruct
}, ref) => {
    const dispatch = useDispatch<AppDispatch>();
    const { earnings: masterEarnings } = useSelector((state: any) => state.payroll.earning);
    const { deductions: masterDeductions } = useSelector((state: any) => state.payroll.deduction);
    const { overtimePays } = useSelector((state: any) => state.payroll.overtimRate);
    const { user } = useSelector((state: any) => state.auth);
    const { employees } = useSelector((state: any) => state.employee);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const { salaryStructures, loading, employeeSalaryStructureLogs = [] } = useSelector((state: any) => state.payroll.salaryStructure);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
    const createdEmployeeId = useSelector((state: RootState) => state.employee.createdEmployeeId);

    const [basicAmount, setBasicAmount] = useState(0);
    const employeeData = employees ? employees : [];
    const { payscales } = useSelector((state: any) => state.payroll.payrollScall);
    const { employeeFullDetails } = useSelector((state: any) => state.employee);
    // const employeeId = employeeFullDetails?.employee[0]?.EmployeeID
    const currentEmployeeId = employeeId || employeeFullDetails?.employee[0]?.EmployeeID;

    const initialEarningDeductionItem: EarningDeductionItem = { name: '', calculateUpon: '', percent: '', id: '', amount: 0, earning_id: '' };
    const [earningsData, setEarningsData] = useState<EarningDeductionItem[]>([initialEarningDeductionItem]);
    const [deductionsData, setDeductionsData] = useState<EarningDeductionItem[]>([initialEarningDeductionItem]);
    const activeEmpl = filterByStatus(employeeData, 'active', "employee_status");

    useImperativeHandle(ref, () => ({
        handleSubmit,
        showEditHeadsUp,
        salaryStructures,
        employeeSalaryData,
        earningsData,
        deductionsData,
        // validateSalaryStructure
    }));

    const [selectedEmployeeId, setSelectedEmployeeId] = useState<any>(null);
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);


    const [employeeSalaryData, setEmployeeSalaryData] = useState({
        employee_id: '',
        pay_scale_id: '',
        net_salary: 0,
        start_date: '',
        end_date: '',
        overtime_pay_id: '',
        status: 'active'
    });
    const [errors, setErrors] = useState({
        employee_id: '',
        pay_scale_id: '',
        net_salary: '',
        start_date: '',
        end_date: '',
        overtime_pay_id: ''
    });

    const resetForm = () => {
        setEmployeeSalaryData({
            employee_id: '',
            pay_scale_id: '',
            net_salary: 0,
            start_date: '',
            end_date: '',
            overtime_pay_id: '',
            status: 'active'
        });
        setEarningsData([initialEarningDeductionItem]);
        setDeductionsData([initialEarningDeductionItem]);
        setBasicAmount(0);
        setErrors({ employee_id: '', pay_scale_id: '', net_salary: '', start_date: '', end_date: '', overtime_pay_id: '' });
    };

    const [isPayscaleAutoFilled, setIsPayscaleAutoFilled] = useState(false);

    useEffect(() => {
        if (employeeSalaryData.employee_id && payscales?.length > 0) {
            const selectedEmp = employeeData.find(
                (emp: any) => emp.EmployeeID === employeeSalaryData.employee_id
            );

            const empExperience = selectedEmp?.experience;
            const empRoleId = selectedEmp?.role_id;

            if (empExperience !== null && empExperience !== undefined && empRoleId !== null && empRoleId !== undefined) {
                const matchedPayscale = payscales.find(
                    (ps: any) =>
                        ps.ExperienceLevel === empExperience.toString() &&
                        ps.RoleId === empRoleId
                );

                if (matchedPayscale) {
                    handleInputChange({ target: { value: matchedPayscale.Id } }, 'pay_scale_id');
                    setIsPayscaleAutoFilled(true);
                } else {
                    setIsPayscaleAutoFilled(false);
                }
            } else {
                setIsPayscaleAutoFilled(false);
            }
        }
    }, [employeeSalaryData.employee_id, payscales, employeeData]);

    useEffect(() => {
        if (employeeId && salaryStructures?.length > 0) {
            const matchedStructure = salaryStructures.find(
                (s: any) => String(s.employee_id) === String(employeeId)
            );

            if (matchedStructure) {
                handleEditSalaryStructureData(matchedStructure);
            } else {
                resetForm();
                setEmployeeSalaryData((prev) => ({
                    ...prev,
                    employee_id: employeeId,
                }));
            }
        }
    }, [employeeId, salaryStructures]);



    const getRecalculatedComponents = (
        currentBasic: number,
        currentEarnings: EarningDeductionItem[],
        currentDeductions: EarningDeductionItem[]
    ) => {
        const recalculatedEarnings = currentEarnings.map(earning => {
            if (earning.name !== 'Basic' && earning.percent && parseFloat(earning.percent) > 0) {
                return {
                    ...earning,
                    amount: parseFloat(((currentBasic * parseFloat(earning.percent)) / 100).toFixed(2))
                };
            }
            return earning;
        });

        const recalculatedDeductions = currentDeductions.map(deduction => {
            if (deduction.percent && parseFloat(deduction.percent) > 0) {
                return {
                    ...deduction,
                    amount: parseFloat(((currentBasic * parseFloat(deduction.percent)) / 100).toFixed(2))
                };
            }
            return deduction;
        });
        return { finalEarnings: recalculatedEarnings, finalDeductions: recalculatedDeductions };
    };

    const handleRemoveEarning = (index: number) => setEarningsData(earningsData.filter((_, i) => i !== index));
    const handleAddEarning = () => setEarningsData([...earningsData, { ...initialEarningDeductionItem }]);
    const handleAddDeduction = () => setDeductionsData([...deductionsData, { ...initialEarningDeductionItem }]);
    const handleRemoveDeduction = (index: number) => setDeductionsData(deductionsData.filter((_, i) => i !== index));

    // add second param with default
    const handleEditSalaryStructureData = (record: any, refreshFromMaster: boolean = false): void => {

        setSelectedRowData(record);

        const startDate = record.start_date ? FormatFeildDate(record?.start_date).slice(0, 10) : '';
        const endDate = record.end_date ? FormatFeildDate(record?.end_date).slice(0, 10) : '';

        // Find existing Basic from the structure
        const existingBasic = Number(
            record.earnings?.find((e: any) => e.earning_name === 'Basic')?.amount ?? 0
        );

        // If refreshing, try to take Basic from master if present, else fall back
        const masterBasic = masterEarnings?.find((m: any) => m.Name === 'Basic');
        const basicFromMaster = masterBasic ? Number(masterBasic.Amount ?? existingBasic) : existingBasic;
        const nextBasic = refreshFromMaster ? basicFromMaster : existingBasic;

        // Helper to compute earning amount when refreshing
        const computeEarningAmount = (structItem: any) => {
            const m = masterEarnings?.find((me: any) => me.Id === Number(structItem.earning_id));
            if (!refreshFromMaster || !m) return Number(structItem.amount);

            // Update by master: prefer Percent when available; otherwise Amount; otherwise keep
            const percent = m.Percent != null && m.Percent !== '' ? Number(m.Percent) : undefined;

            if (m.Name === 'Basic') {
                return Number(m.Amount ?? structItem.amount ?? nextBasic);
            }
            if (percent && !Number.isNaN(percent) && percent > 0) {
                return Number(((nextBasic * percent) / 100).toFixed(2));
            }
            if (m.Amount != null && m.Amount !== '') {
                return Number(m.Amount);
            }
            return Number(structItem.amount);
        };

        // Helper to compute deduction amount when refreshing
        const computeDeductionAmount = (structItem: any) => {
            const m = masterDeductions?.find((md: any) => md.Id === Number(structItem.deduction_id));
            if (!refreshFromMaster || !m) return Number(structItem.amount);

            const percent = m.Percent != null && m.Percent !== '' ? Number(m.Percent) : undefined;

            if (percent && !Number.isNaN(percent) && percent > 0) {
                return Number(((nextBasic * percent) / 100).toFixed(2));
            }
            if (m.Amount != null && m.Amount !== '') {
                return Number(m.Amount);
            }
            return Number(structItem.amount);
        };

        // Earnings
        let initialBasic = 0;
        const earningsFormatted = (record.earnings || []).map((earning: any) => {
            const master = masterEarnings?.find((me: any) => me.Id === Number(earning.earning_id));

            // name & percent possibly updated from master if refreshing
            const name = refreshFromMaster && master ? master.Name : earning.earning_name;
            const percent =
                refreshFromMaster && master && master.Percent != null && master.Percent !== ''
                    ? String(master.Percent)
                    : earning.percent
                        ? String(earning.percent)
                        : '';

            const amount = computeEarningAmount(earning);

            if (name === 'Basic') initialBasic = amount;

            return {
                name,
                amount: Number(amount),
                id: String(earning.earning_id),
                earning_id: String(earning.id),
                percent,
                calculateUpon:
                    master?.CalculatedUpon ??
                    masterEarnings.find((me: any) => me.Id === Number(earning.earning_id))?.CalculatedUpon ??
                    '',
            };
        });

        // If Basic wasn’t present, fall back to nextBasic
        if (!initialBasic) initialBasic = nextBasic;

        // Deductions
        const deductionsFormatted = (record.deductions || []).map((deduction: any) => {
            const master = masterDeductions?.find((md: any) => md.Id === Number(deduction.deduction_id));

            const name = refreshFromMaster && master ? master.Name : deduction.deduction_name;
            const percent =
                refreshFromMaster && master && master.Percent != null && master.Percent !== ''
                    ? String(master.Percent)
                    : deduction.percent
                        ? String(deduction.percent)
                        : '';

            const amount = computeDeductionAmount(deduction);

            return {
                name,
                amount: Number(amount),
                id: String(deduction.deduction_id),
                deduction_id: String(deduction.id),
                percent,
                calculateUpon:
                    master?.CalculatedUpon ??
                    masterDeductions.find((md: any) => md.Id === Number(deduction.deduction_id))?.CalculatedUpon ??
                    '',
            };
        });

        setEmployeeSalaryData({
            employee_id: record.employee_id,
            pay_scale_id: record.pay_scale_id,
            net_salary: record.net_salary, // will recalc on render anyway
            status: record.status,
            start_date: startDate,
            end_date: endDate,
            overtime_pay_id: record.overtime_pay_id,
        });

        setBasicAmount(initialBasic);
        setEarningsData(earningsFormatted.length > 0 ? earningsFormatted : [initialEarningDeductionItem]);
        setDeductionsData(deductionsFormatted.length > 0 ? deductionsFormatted : [initialEarningDeductionItem]);

        // showModal('edit');
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const calculateNetSalary = useCallback(() => {
        const totalEarnings = earningsData.reduce((acc, earning) => acc + (earning.amount || 0), 0);
        const totalDeductions = deductionsData.reduce((acc, deduction) => acc + (deduction.amount || 0), 0);
        const net_salary = totalEarnings - totalDeductions;

        setEmployeeSalaryData((prevState) => ({
            ...prevState,
            net_salary: parseFloat(net_salary.toFixed(2)),
        }));
    }, [earningsData, deductionsData]);

    useEffect(() => {
        calculateNetSalary();
    }, [calculateNetSalary]);

    const handleInputChange = (e: any, field: string) => {
        const { value } = e.target;
        setEmployeeSalaryData((prevState) => ({ ...prevState, [field]: value, }));
        setErrors((prevErrors: any) => ({ ...prevErrors, [field]: '', }));
    };

    const handleEarningSelect = (index: number, earningIdStr: string) => {
        const earningId = parseInt(earningIdStr);
        const selectedMasterEarning = masterEarnings.find((earning: any) => earning.Id === earningId);

        if (selectedMasterEarning) {
            const mutableEarnings = [...earningsData];
            const percentStr = selectedMasterEarning.Percent ? selectedMasterEarning.Percent.toString() : '';
            const percentNum = parseFloat(percentStr);

            let calculatedAmount = parseFloat(selectedMasterEarning.Amount || 0);

            if (selectedMasterEarning.Name === 'Basic') {
            } else if (basicAmount > 0 && percentStr && percentNum > 0) {
                calculatedAmount = parseFloat(((basicAmount * percentNum) / 100).toFixed(2));
            }

            mutableEarnings[index] = {
                name: selectedMasterEarning.Name,
                calculateUpon: selectedMasterEarning.CalculatedUpon,
                percent: percentStr,
                id: selectedMasterEarning.Id.toString(),
                amount: calculatedAmount,
                earning_id: earningsData[index].earning_id || '',
            };

            if (selectedMasterEarning.Name === 'Basic') {
                setBasicAmount(calculatedAmount);
                const { finalEarnings, finalDeductions } = getRecalculatedComponents(
                    calculatedAmount,
                    mutableEarnings,
                    deductionsData
                );
                setEarningsData(finalEarnings);
                setDeductionsData(finalDeductions);
            } else {
                setEarningsData(mutableEarnings);
            }
        }
    };

    const handleDeductionSelect = (index: number, deductionIdStr: string) => {
        const deductionId = parseInt(deductionIdStr);
        const selectedMasterDeduction = masterDeductions.find((deduction: any) => deduction.Id === deductionId);

        if (selectedMasterDeduction) {
            const mutableDeductions = [...deductionsData];
            const percentStr = selectedMasterDeduction.Percent ? selectedMasterDeduction.Percent.toString() : '';
            const percentNum = parseFloat(percentStr);

            let calculatedAmount = parseFloat(selectedMasterDeduction.Amount || 0); // Default to master amount or 0

            if (basicAmount > 0 && percentStr && percentNum > 0) {
                calculatedAmount = parseFloat(((basicAmount * percentNum) / 100).toFixed(2));
            }

            mutableDeductions[index] = {
                name: selectedMasterDeduction.Name,
                calculateUpon: selectedMasterDeduction.CalculatedUpon,
                id: selectedMasterDeduction.Id.toString(),
                percent: percentStr,
                amount: calculatedAmount,
                deduction_id: deductionsData[index].deduction_id || '', // Preserve existing PK
            };
            setDeductionsData(mutableDeductions);
        }
    };

    const handleAmountChange = (index: number, value: number, type: 'earning' | 'deduction') => {
        if (type === 'earning') {
            const tempUpdatedEarnings = [...earningsData];
            tempUpdatedEarnings[index].amount = isNaN(value) ? 0 : value; // Ensure value is a number

            if (tempUpdatedEarnings[index].name === 'Basic') {
                const newBasic = isNaN(value) ? 0 : value;
                setBasicAmount(newBasic); // Update the global basic amount state

                const { finalEarnings, finalDeductions } = getRecalculatedComponents(
                    newBasic,               // Use the new user-inputted basic amount
                    tempUpdatedEarnings,    // Pass the array that includes the just-modified Basic amount
                    deductionsData
                );
                setEarningsData(finalEarnings);
                setDeductionsData(finalDeductions);
            } else {
                // If a non-Basic earning amount is changed, just update that earning
                setEarningsData(tempUpdatedEarnings);
            }
        } else if (type === 'deduction') {
            const updatedDeductions = [...deductionsData];
            updatedDeductions[index].amount = isNaN(value) ? 0 : value; // Ensure value is a number
            setDeductionsData(updatedDeductions);
        }
    };

    useEffect(() => {
        // Initial data fetching
        if (!employees?.length) dispatch(getEmployees());
        if (!payscales?.length) dispatch(fetchPayscales());
        if (!masterEarnings?.length) dispatch(fetchEarnings());
        if (!masterDeductions.length) dispatch(fetchDeductions());
        if (!salaryStructures?.length) dispatch(fetchEmployeeSalaryStructures());
        if (overtimePays?.length === 0) dispatch(fetchOvertimePays());
    }, [dispatch]);

    const validateForm = () => {
        // Validation logic remains the same
        let isValid = true;
        const newErrors: any = {};
        if (!employeeSalaryData.employee_id) { newErrors.employee_id = 'Please select an employee'; isValid = false; }
        if (!employeeSalaryData.pay_scale_id) { newErrors.pay_scale_id = 'Please select a payscale'; isValid = false; }
        // if (!employeeSalaryData.overtime_pay_id) { newErrors.overtime_pay_id = 'Please select a overtime Pay'; isValid = false; }
        if (employeeSalaryData.net_salary <= 0) { newErrors.net_salary = 'Net Salary must be greater than 0'; isValid = false; }
        if (!employeeSalaryData.start_date) { newErrors.start_date = 'Please select a start date'; isValid = false; }
        if (!employeeSalaryData.end_date) { newErrors.end_date = 'Please select an end date'; isValid = false; }
        else if (new Date(employeeSalaryData.end_date) <= new Date(employeeSalaryData.start_date)) { newErrors.end_date = 'End date must be after start date'; isValid = false; }
        setErrors(newErrors);
        return isValid;
    };

    const onSalaryStructureSuccess = async (res: any, showMessage = true) => {
        if (showMessage) message.success(res?.message || res?.Message || 'Employee Salary Structure saved successfully');
        await dispatch(fetchEmployeeSalaryStructures());
        setTableKey((prev: number) => prev + 1);
        // resetForm();
    };

    const confirmSalaryEdit = (onOk: () => Promise<void | boolean>, startDate?: string): Promise<boolean> =>
        new Promise((resolve, reject) => {
            Modal.confirm({
                title: 'Confirm salary structure update',
                content:
                    `You’re about to update this employee’s salary structure.\n\n` +
                    `This will NOT affect any previously processed months.\n` +
                    `The change will apply to future payrolls starting from ${startDate || 'the selected start date'}.\n\n` +
                    `Proceed?`,
                okText: 'Update salary structure',
                cancelText: 'Cancel',
                centered: true,
                async onOk() {
                    try {
                        await onOk();
                        resolve(true);
                    } catch (err) {
                        reject(err);
                    }
                },
                onCancel() {
                    resolve(false);
                },
            })
        });

    const handleSubmit = async (e?: React.FormEvent, showMessage = true, showConfirm = true): Promise<boolean> => {
        // e?.preventDefault();
        if (!employeeSalaryData.pay_scale_id || !employeeSalaryData.start_date || !employeeSalaryData.end_date) { if (showMessage) message.warning('Please fill all fields to add/update salary structure'); return false; }

        if (modalType === 'edit') {
            if (showMessage) {
                const isValid = validateForm();
                if (!isValid) return false;
            }
        }

        const updatedFormData = {
            ...employeeSalaryData,
            employee_id: Number(employeeSalaryData.employee_id || selectedRowData?.employee_id || createdEmployeeId),
            overtime_pay_id: employeeSalaryData.overtime_pay_id || null,
            CreatedBy: modalType === 'create' ? user.UserId : undefined,
            ModifiedBy: modalType === 'edit' ? user.UserId : undefined,
            earnings: earningsData
                .filter((e) => e.id && e.name)
                .map((earning) => ({
                    earning_name: earning.name,
                    amount: earning.amount,
                    id: earning.earning_id,
                    earning_id: earning.id,
                    percent:
                        earning.percent !== '' && earning.percent !== undefined
                            ? Number(earning.percent)
                            : null,
                    CreatedBy: user.UserId,
                })),
            deductions: deductionsData
                .filter((d) => d.id && d.name)
                .map((deduction) => ({
                    deduction_name: deduction.name,
                    amount: deduction.amount,
                    id: deduction.deduction_id,
                    deduction_id: deduction.id,
                    percent:
                        deduction.percent !== '' && deduction.percent !== undefined
                            ? Number(deduction.percent)
                            : null,
                    CreatedBy: user.UserId,
                })),
        };
        if (!updatedFormData.employee_id) {
            message.error("Cannot create salary structure: missing employee ID");
            return false;
        }

        try {
            if (modalType === 'create') {
                const res = await dispatch(createEmployeeSalaryStructure(updatedFormData)).unwrap();
                await onSalaryStructureSuccess(res, showMessage);
                return true;
            }

            if (modalType === 'edit') {
                if (!selectedRowData?.salary_structure_id) {
                    const res = await dispatch(createEmployeeSalaryStructure(updatedFormData)).unwrap();
                    await onSalaryStructureSuccess(res, showMessage);
                    return true;
                }

                if (showConfirm) {
                    return confirmSalaryEdit(
                        async () => {
                            const res = await dispatch(
                                updateEmployeeSalaryStructure({
                                    id: selectedRowData.salary_structure_id,
                                    ...updatedFormData,
                                })
                            ).unwrap();
                            await onSalaryStructureSuccess(res, showMessage);
                        },
                        employeeSalaryData.start_date
                    ).then(() => true).catch(() => false);
                } else {
                    // 🔥 skip confirm modal in global save
                    const res = await dispatch(
                        updateEmployeeSalaryStructure({
                            id: selectedRowData.salary_structure_id,
                            ...updatedFormData,
                        })
                    ).unwrap();
                    await onSalaryStructureSuccess(res, showMessage);
                    return true;
                }
            }
            return true;
        } catch (error: any) {
            const errorMessage = error?.error || error?.message || 'An error occurred during submission.';
            if (showMessage) message.error(errorMessage);
            return false;
        }
    };


    const handleDeleteSalaryStructure = async (id: number) => {
        // ... (delete logic remains same)
        try {
            const result = await dispatch(deleteEmployeeSalaryStructure(id));
            if (result.meta.requestStatus === 'fulfilled') {
                message.success('Salary Structure deleted successfully'); // Changed alert to message
                await dispatch(fetchEmployeeSalaryStructures());
                setTableKey((prevKey: any) => prevKey + 1);
                setIsDeleteModalVisible(false);
            } else {
                message.error(result.payload.error || 'Failed to delete salary structure.'); // Changed alert to message
            }
        } catch (error) {
            message.error('Something went wrong during deletion.'); // Changed alert to message
        }
    };

    const handleCreateSameStructure = () => {
        // ... (logic for create same structure remains same)
        if (!selectedRowData) return;
        const newSalaryData = {
            employee_id: '', // Clear employee ID for new structure
            pay_scale_id: selectedRowData.pay_scale_id,
            net_salary: selectedRowData.net_salary,
            status: 'active', // Default to active for new one
            start_date: '', // Clear dates or set to today
            end_date: '',   // Clear dates
            overtime_pay_id: selectedRowData.overtime_pay_id
        };

        let initialBasic = 0;
        const earningsFormatted = selectedRowData.earnings.map((earning: any) => {
            if (earning.earning_name === 'Basic') {
                initialBasic = parseFloat(earning.amount);
            }
            return {
                name: earning.earning_name,
                amount: parseFloat(earning.amount),
                id: earning.earning_id.toString(),
                earning_id: '', // This will be a new record, so no existing PK
                percent: earning.percent ? earning.percent.toString() : '',
                calculateUpon: masterEarnings.find((me: any) => me.Id === earning.earning_id)?.CalculatedUpon || ''
            };
        });

        const deductionsFormatted = selectedRowData.deductions.map((deduction: any) => ({
            name: deduction.deduction_name,
            amount: parseFloat(deduction.amount),
            id: deduction.deduction_id.toString(),
            deduction_id: '', // New record
            percent: deduction.percent ? deduction.percent.toString() : '',
            calculateUpon: masterDeductions.find((md: any) => md.Id === deduction.deduction_id)?.CalculatedUpon || ''
        }));

        setBasicAmount(initialBasic);
        setEmployeeSalaryData(newSalaryData);
        setEarningsData(earningsFormatted.length > 0 ? earningsFormatted : [initialEarningDeductionItem]);
        setDeductionsData(deductionsFormatted.length > 0 ? deductionsFormatted : [initialEarningDeductionItem]);
        setErrors({ employee_id: '', pay_scale_id: '', net_salary: '', start_date: '', end_date: '', overtime_pay_id: '' });
        // setModalType('create'); // Set to create mode
        setIsModalVisible(true);
    };

    const [selectedStatus, setSelectedStatus] = useState('active');
    const [selectedSort, setSelectedSort] = useState<any>("");

    const data = salaryStructures;
    const filteredData = useMemo(() => {
        const filters =
            selectedStatus && selectedStatus !== "All"
                ? { status: selectedStatus }
                : {};
        return filterData(data || [], filters, "CreatedAt", "CreatedAt", selectedSort)
    }, [data, selectedSort, selectedStatus]);

    const ExportData = filteredData.map((item: any) => ({
        EmployeeNumber: item.EmployeeNumber || "N/A",
        EmployeeName: item.EmployeeName || "N/A",
        MobileNumber: item.MobileNumber || "N/A",
        employee_id: item.employee_id || "N/A",
        pay_scale_id: item.pay_scale_id || "N/A",
        net_salary: item.net_salary ?? 0,
        status: item.status || "Inactive",
        start_date: item.start_date ? new Date(item.start_date).toLocaleDateString("en-IN") : "N/A",
        end_date: item.end_date ? new Date(item.end_date).toLocaleDateString("en-IN") : "N/A",
        overtime_pay_id: item.overtime_pay_id || "N/A",
        CreatedBy: item.CreatedBy || "N/A",
        CreatedAt: item.CreatedAt ? new Date(item.CreatedAt).toLocaleDateString("en-IN") : "N/A",
        JoiningDate: item.JoiningDate ? new Date(item.JoiningDate).toLocaleDateString("en-IN") : "N/A",
        EmployeeDesignation: item.EmployeeDesignation || "N/A",
    }));


    useEffect(() => {
        setTableKey(prevKey => prevKey + 1);
    }, [selectedSort, selectedStatus, salaryStructures]);

    const config = useAppConfig();

    const handleShowLogs = (record: any) => {
        const empId = Number(record?.employee_id);
        if (!empId) return;
        setSelectedEmployeeId(empId);
        dispatch(fetchSalaryStructureLogsByEmployeeId({ employeeId: empId }));
        setIsDrawerVisible(true);
    };
    const cap = (s?: string) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : '-');
    const actionTagColor = (a?: string) =>
        a === 'INSERT' ? 'green' : a === 'UPDATE' ? 'blue' : a === 'DELETE' ? 'red' : 'default';

    const safeDate = (d?: string | null) => (d ? dateFormat(d, config) : '-');
    const safeMoney = (n?: string | number) =>
        formatCurrency(Number(n || 0), config);

    const showEditHeadsUp = (record: any) =>
        Modal.confirm({
            title: 'Update component heads from master?',
            content: (
                <>
                    <div>
                        Choose <strong>Use updated masters</strong> to refresh earning/deduction amounts & percentages from the
                        current master settings, or <strong>Keep existing</strong> to edit with the values this structure already has.
                    </div>
                </>
            ),
            okText: 'Use updated masters',
            cancelText: 'Keep existing',
            centered: true,
            onOk: () => handleEditSalaryStructureData(record, true),
            onCancel: () => handleEditSalaryStructureData(record, false),
        });

    return (
        <div className="container mt-4">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="row">
                        {/* Payscale */}
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">
                                    Payscale <span className="text-danger"> *</span>
                                </label>
                                <select
                                    className="form-select"
                                    value={employeeSalaryData.pay_scale_id}
                                    onChange={(e) => handleInputChange(e, "pay_scale_id")}
                                    disabled={isPayscaleAutoFilled || modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false}
                                >
                                    <option value="">Select Payscale</option>
                                    {payscales?.map((pay: any) => (
                                        <option key={pay.Id} value={pay.Id}>
                                            {pay.SalaryRangeMin} - {pay.SalaryRangeMax}
                                        </option>
                                    ))}
                                </select>
                                {errors.pay_scale_id && (
                                    <div className="text-danger" style={{ fontSize: "12px" }}>
                                        {errors.pay_scale_id}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Overtime Pay */}
                        <div className="col-md-6">
                            <div className="mb-3">
                                <label className="form-label">Overtime Pay</label>
                                <select
                                    className="form-select"
                                    value={employeeSalaryData.overtime_pay_id}
                                    onChange={(e) => handleInputChange(e, "overtime_pay_id")}
                                    disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false}
                                >
                                    <option value="">Select Overtime Pay Rule</option>
                                    {overtimePays?.map((pay: any) => (
                                        <option key={pay.ID} value={pay.ID}>
                                            {pay.Name}
                                        </option>
                                    ))}
                                </select>
                                {errors.overtime_pay_id && (
                                    <div className="text-danger" style={{ fontSize: "12px" }}>
                                        {errors.overtime_pay_id}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div>
                        <h5 className="text-primary mb-2">Earnings</h5>
                        <table className="table table-bordered table-sm"> {/* table-sm for smaller padding */}
                            <thead><tr><th style={{ width: '5%' }}>#</th><th style={{ width: '40%' }}>Name</th><th style={{ width: '30%' }}>Amount</th><th style={{ width: '25%' }}>Action</th></tr></thead>
                            <tbody>
                                {earningsData.map((earning, index) => (
                                    <tr key={`earning-${index}`}> {/* Ensure unique key */}
                                        <td>{index + 1}</td>
                                        <td className="position-relative">
                                            <select className="form-select form-select-sm" value={earning.id || ''} onChange={(e) => handleEarningSelect(index, e.target.value)} disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false}>
                                                <option value="">Select Earning</option>
                                                {masterEarnings?.filter((e: any) => !earningsData.some((ed, idx) => idx !== index && ed.id === e.Id.toString())).map((e: any) => (<option key={e.Id} value={e.Id}>{e.Name}</option>))}
                                            </select>
                                            {earning?.percent && parseFloat(earning.percent) > 0 && (<span className="form-label text-danger position-absolute" style={{ right: '34px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.8em' }}>{earning.percent}%</span>)}
                                        </td>
                                        <td><input type="text" className="form-control form-control-sm text-end" disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false} value={earning.amount} onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                handleAmountChange(index, parseFloat(value) || 0, 'earning');
                                            }
                                        }} /></td>
                                        <td>
                                            {earningsData.length > 1 && (<button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemoveEarning(index)}><MinusOutlined style={{ color: "#000" }} /></button>)}
                                            {index === earningsData.length - 1 && (<button type="button" className="btn btn-success btn-sm ms-1" onClick={handleAddEarning}><PlusOutlined style={{ color: "#000" }} /></button>)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        <h5 className="text-primary mb-2 mt-3">Deductions</h5>
                        <table className="table table-bordered table-sm">
                            <thead><tr><th style={{ width: '5%' }}>#</th><th style={{ width: '40%' }}>Name</th><th style={{ width: '30%' }}>Amount</th><th style={{ width: '25%' }}>Action</th></tr></thead>
                            <tbody>
                                {deductionsData.map((deduction, index) => (
                                    <tr key={`deduction-${index}`}>
                                        <td>{index + 1}</td>
                                        <td className="position-relative">
                                            <select className="form-select form-select-sm" value={deduction.id || ''} onChange={(e) => handleDeductionSelect(index, e.target.value)} disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false}>
                                                <option value="">Select Deduction</option>
                                                {masterDeductions?.filter((d: any) => !deductionsData.some((dd, idx) => idx !== index && dd.id === d.Id.toString())).map((d: any) => (<option key={d.Id} value={d.Id}>{d.Name}</option>))}
                                            </select>
                                            {deduction?.percent && parseFloat(deduction.percent) > 0 && (<span className="form-label text-danger position-absolute" style={{ right: '34px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.8em' }}>{deduction.percent}%</span>)}
                                        </td>
                                        <td><input type="text" className="form-control form-control-sm text-end" disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false} value={deduction.amount} onChange={(e) => {
                                            const value = e.target.value;
                                            if (/^\d*\.?\d*$/.test(value)) {
                                                handleAmountChange(index, parseFloat(value) || 0, 'deduction');
                                            }
                                        }} /></td>
                                        <td>
                                            {deductionsData.length > 1 && (<button type="button" className="btn btn-danger btn-sm" onClick={() => handleRemoveDeduction(index)}><MinusOutlined style={{ color: "#000" }} /></button>)}
                                            {index === deductionsData.length - 1 && (<button type="button" className="btn btn-success btn-sm ms-1" onClick={handleAddDeduction}><PlusOutlined style={{ color: "#000" }} /></button>)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-6"><div className="mb-3"><label className="form-label">Start Date <span className="text-danger"> *</span></label><input type="date" className="form-control" value={employeeSalaryData?.start_date} onChange={(e) => handleInputChange(e, 'start_date')} min={modalType === 'create' ? today : undefined} disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false} />{errors.start_date && <div className="text-danger" style={{ fontSize: '12px' }}>{errors.start_date}</div>}</div></div>
                        <div className="col-md-6"><div className="mb-3"><label className="form-label">End Date <span className="text-danger"> *</span></label><input type="date" className="form-control" value={employeeSalaryData?.end_date} onChange={(e) => handleInputChange(e, 'end_date')} min={employeeSalaryData?.start_date || today} disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false} />{errors.end_date && <div className="text-danger" style={{ fontSize: '12px' }}>{errors.end_date}</div>}</div></div>
                    </div>
                    <div className="row">
                        <div className="col-md-6"><div className="mb-3"><label className="form-label">Net Salary</label><input type="text" className="form-control text-end" value={`${employeeSalaryData?.net_salary !== undefined && employeeSalaryData.net_salary !== null ? employeeSalaryData.net_salary.toLocaleString() : '0'}`} readOnly disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false} />{errors.net_salary && <div className="text-danger" style={{ fontSize: '12px' }}>{errors.net_salary}</div>}</div></div>
                        <div className="col-md-6"><div className="mb-3 "><label className="form-label">Status</label><select className="form-select" value={employeeSalaryData.status} onChange={(e) => handleInputChange(e, 'status')} disabled={modalType === "edit" ? !editingSlaryStruct.EditsalaryStructure : false}>{status.map((item: any) => (<option key={item.value} value={item.value}>{item.label}</option>))}</select></div></div>
                    </div>
                </div>
                {/* <div className="modal-footer" style={{ position: 'sticky', bottom: 0, backgroundColor: 'white', zIndex: 1, padding: '1rem' }}> 
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                    >
                        {modalType === 'create' ? 'Salary Structure' : ' Update Salary Structure'}
                    </button>
                </div> */}
            </form>
        </div >
    )
})

export default EmployeeSalaryStructureModal